// =====================================================
// AGING ROSE - COMMON SCRIPTS
// 全セクション共通のJS。ar-cta.liquidの末尾でのみ読み込む。
// 対象要素が存在しないページでもエラーにならないよう
// 各機能はガード付きで実行する。
// =====================================================

// ===== SCROLL REVEAL =====
var revealEls = document.querySelectorAll(".reveal");
if (revealEls.length) {
  var revealObs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          revealObs.unobserve(e.target);
        }
      });
    },
    { threshold: 0.15 },
  );
  revealEls.forEach(function (el) {
    revealObs.observe(el);
  });
}

// ===== HEADER SHOW/HIDE ON SCROLL =====
var header = document.getElementById("siteHeader");
if (header) {
  var lastY = 0;

  window.addEventListener(
    "scroll",
    function () {
      var y = window.scrollY;
      if (y < 10) {
        header.classList.add("at-top");
      } else {
        header.classList.remove("at-top");
        if (y < lastY) {
          header.classList.add("visible");
        } else {
          header.classList.remove("visible");
        }
      }
      lastY = y;
    },
    { passive: true },
  );

  // init: show at top
  header.classList.add("at-top");
}

// ===== AGING SHAPE FADE =====
var agingShape = document.getElementById("agingShape");
var agingContent = document.querySelector(".aging-content");

if (agingShape && agingContent) {
  agingShape.style.opacity = "0.2";

  var agingTrigger = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          agingShape.style.opacity = "0.9";
          agingTrigger.unobserve(e.target);
        }
      });
    },
    {
      threshold: 0.5,
      rootMargin: "0px 0px -30% 0px",
    },
  );

  agingTrigger.observe(agingContent);
}
